import { ProfileApprovalStatusEnum as ProfileApprovalStatusEnumServer } from "@sinch/core/entities/serverEnums";
import { ProfileApprovalStatusEnum } from "@sinch/types/sinch.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

const APPROVED_BACKGROUND = "#5cb85c";
const UNAPPROVED_BACKGROUND = "#dfba49";

/**
 * Single source of truth for how a profile approval status looks in the app: label and color.
 *
 * Use these getters wherever a profile approval status is shown.
 * Never hardcode its label and color in a component, change them here.
 * Every value is shown in the "Entity Identity/ProfileApprovalStatus" story.
 */
export const useProfileApprovalStatus = () => {
  const { t } = useTranslation();

  /**
   * Mapping of profile approval statuses to their display properties
   */
  const ProfileApprovalStatuses = {
    [ProfileApprovalStatusEnumServer.Approved]: {
      label: t("ProfileApprovalStatus.approved"),
      color: APPROVED_BACKGROUND,
    },
    [ProfileApprovalStatusEnumServer.Declined]: {
      label: t("ProfileApprovalStatus.declined"),
      color: UNAPPROVED_BACKGROUND,
    },
    [ProfileApprovalStatusEnumServer.NotFilled]: {
      label: t("ProfileApprovalStatus.notFilled"),
      color: UNAPPROVED_BACKGROUND,
    },
    [ProfileApprovalStatusEnumServer.PendingChanges]: {
      label: t("ProfileApprovalStatus.pendingChanges"),
      color: UNAPPROVED_BACKGROUND,
    },
    [ProfileApprovalStatusEnumServer.PendingReview]: {
      label: t("ProfileApprovalStatus.pendingReview"),
      color: UNAPPROVED_BACKGROUND,
    },
  } as Record<ProfileApprovalStatusEnumServer | ProfileApprovalStatusEnum, { label: string; color: string }>;
  const getProp = useEntityProps(ProfileApprovalStatuses);

  const getProfileApprovalStatusLabel = getProp<string>("label");
  const getProfileApprovalStatusColor = getProp<string>("color");

  return { getProfileApprovalStatusLabel, getProfileApprovalStatusColor };
};
